/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Header, Form, Button, Segment, Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";
import sha256 from "js-sha256";

const UtilsInstance = new Utils();

class Login extends Component {

  handleSubmit = () => {
    let loginData = JSON.stringify({
      login: document.getElementById("login").value,
      password: sha256(document.getElementById("password").value),
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "login_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: loginData
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        sessionStorage.auth = Constants.AUTH_STR;
        this.props.history.push({ pathname: "/config" });
      })
      .catch(function (error) {
        if (undefined !== error.response) {
          if (error.response.status === 401) {
            alert(Strings.LOGIN_CREDENTIALS_FAILURE);
          }
          else {
            alert(Strings.LOGIN_GENERAL_FALIURE + error);
          }
        }
      });
  };

  render() {
    return (
      <div className="ts-login-page">
        <Segment className="ts-login-card">
          <div className="ts-login-icon">
            <Icon name="lock" />
          </div>

          <Header as="h2" textAlign="center" className="ts-login-title">LOGIN</Header>

          <Form className="ts-login-form" onSubmit={this.handleSubmit}>
            <Form.Input
              id="login"
              icon="user outline"
              iconPosition="left"
              label={Strings.USER}
              placeholder={Strings.USER}
              name="username"
              type="text"
              autoComplete="off" />

            <Form.Input
              id="password"
              icon="lock"
              iconPosition="left"
              label={Strings.PASSWORD}
              placeholder={Strings.PASSWORD}
              name="password"
              type="password"
              autoComplete="off" />

            <Button className="ts-login-submit" color="teal" fluid type="submit">
              {Strings.ENTER}
            </Button>
          </Form>
        </Segment>
      </div>
    );
  }
}

export default withRouter(Login);